import type { Dayjs } from 'dayjs';

export function formatMonthDateRange(
  start: Dayjs | null | undefined,
  end: Dayjs | null | undefined,
  monthFormat: string,
): string {
  if (!start) {
    return '';
  }

  if (!end) {
    return start.format(monthFormat);
  }

  const isYear =
    start.isSame(start.startOf('year'), 'day') &&
    end.isSame(start.endOf('year'), 'day');

  if (isYear) {
    return start.format('YYYY');
  }

  const isSingleMonth =
    start.isSame(start.startOf('month'), 'day') &&
    end.isSame(start.endOf('month'), 'day');

  if (isSingleMonth) {
    return start.format(monthFormat);
  }

  const formattedStart = start.format(monthFormat);
  const formattedEnd = end.format(monthFormat);
  return `${formattedStart} - ${formattedEnd}`;
}
